
<t-row class="list-view-record" ref="row">
  <bulk-action-checkbox v-if="canTakeBulkActions"  :entry="entry"></bulk-action-checkbox>
  <t-prefix v-if="$feature.isOn('see_underlying_properties')" >
    <button class="btn-icon blue" @click="showSeeUnderlyingPropertiesModal">
      <icon class="inspection"></icon>
      <span class="sr-only">See Underling Properties</span>
    </button>
  </t-prefix>
  <underlying-properties-modal
    @toggle-modal="hideModal(vueModalID.seeUnderlyingProperties)"
    :object-model-entry="entry"
    :object-model="objectModel"
    v-if="modalStateFor(vueModalID.seeUnderlyingProperties).isVisible && isNotOneStop"
    :state="modalStateFor(vueModalID.seeUnderlyingProperties)"
    :index="vueModalID.seeUnderlyingProperties"
  />
  <list-view-content-element-column
    v-for="column in columns"
    :is-in-detail-view-edit-mode="isInDetailViewEditMode"
    :key="`column-${column.id}`"
    :content-element="column"
    :horizontal="horizontal"
    :entry="entry"
    :list-view="listView"
    :user="user"
    :is-user-dashboard="isUserDashboard"
    @updateEntries="updateEntries"
  />
</t-row>
